import { render, staticRenderFns } from "./customers-list.vue?vue&type=template&id=74fe5cc3"
import script from "./customers-list.vue?vue&type=script&lang=js"
export * from "./customers-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports